<template>
<v-navigation-drawer
  :value="value"
  @input="ev => $emit('input', ev)"
  app>
  <v-toolbar height="120" flat>
    <v-img
      height="100"
      contain
      :src="logo" />
  </v-toolbar>

  <v-divider color="white" inset></v-divider>

  <v-list>
    <template v-for="(route, i) in routes">
      <v-list-tile
        active-class="active"
        v-if="route.items.length == 0"
        :to="route.path"
        :key="i">
        <v-list-tile-action v-if="route.icon">
          <v-icon dark>{{ route.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ route.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-group
        v-else
        :key="i"
        v-model="route.open"
        :class="{active: !route.open && containCurrent(route)}"
        no-action>
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>{{ route.title }}</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-tile
          active-class="active"
          v-for="(subRoute, j) in route.items"
          :to="subRoute.path"
          :key="`${i}-${j}`">
          <v-list-tile-action>
            <v-icon dark>mdi-label</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ subRoute.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
    </template>
  </v-list>
</v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('Router');

export default {
  name: 'side-menu',
  props: {
    value: Boolean,
  },
  data: () => ({
    routes: [],
    logo: require('@/assets/tcloud-logo.png'), //eslint-disable-line
  }),
  mounted() {
    this.computeRoutes();
  },
  watch: {
    modalita() {
      this.computeRoutes();
    },
  },
  methods: {
    containCurrent(route) {
      return route.items.map(({ path }) => path).includes(this.currentRoute);
    },
    computeRoutes() {
      const rawRoutes = this.$router.options.routes.filter(route => route.meta && 'parent' in route.meta);
      this.routes = rawRoutes.reduce((c, n) => {
        const last = [...c].pop();
        const { meta, path } = n;
        if (meta.showOn && meta.showOn.indexOf(this.modalita) === -1) return c;
        if (!last || !meta.parent) {
          c.push({
            path,
            title: meta.title,
            items: [],
            icon: meta.icon,
          });
        } else if (last.title === meta.parent) {
          c[c.length - 1].items.push({
            path,
            title: meta.title,
          });
        } else {
          c.push({
            title: meta.parent,
            items: [{
              path,
              title: meta.title,
            }],
            open: false,
          });
        }
        return c;
      }, []);
    },
  },
  computed: {
    ...mapState({
      currentRoute: 'path',
    }),
  },
};
</script>

<style lang="stylus" scoped>
.v-navigation-drawer
  &:after
    content " "
    background-image url('~@/assets/side-menu-bg.jpg')
    position absolute
    filter brightness(20%)
    top 0
    width 100%
    height 100%
    z-index -1
  >>> .v-toolbar
    background transparent
    color white
  >>> .v-list
    background transparent
    > div[role='listitem']
    > .v-list__group
      margin 10px 15px 0
      .v-list__group__items div[role='listitem']
        margin-top 10px
      .v-list__tile
        color white
        padding 10px 15px
        height unset
        .v-list__tile__title
          line-height 30px
          height unset
      .v-list__tile
      .v-list__group__header
        transition .3s cubic-bezier(.25,.8,.5,1)
        .v-list__group__header__append-icon .v-icon
          color white
        &.active
          background-color: var(--v-primary-base)
          box-shadow 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)
      &.active
        .v-list__group__header
          background-color: var(--v-primary-base)
          box-shadow 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)
    > .v-list__group
      &:before
      &:after
        content none
    .v-list__group__header
    .v-list__tile
      border-radius 4px
      .v-list__tile__action
        width 35px
    .v-list__group__header:hover
    .v-list__group__items .v-list__tile:hover:not(.active)
    > div[role='listitem'] .v-list__tile:hover:not(.active)
      background rgba(#ddd, 0.12)
</style>
